<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <edit-icon></edit-icon>
      </span>
    </template>
    <span>{{ message }}</span>
  </v-tooltip>
</template>

<script>
import EditIcon from './Edit'
export default {
  components: {
    EditIcon
  },
  props: {
    message: {
      type: String,
      default: 'Edit'
    }
  }
}
</script>

<style></style>
